import { useContext } from "react";
import Navbar from "../components/navigation/Navbar";
import NavItem from "../components/navigation/NavItem";
import DropdownMenu from "../components/navigation/DropdownMenu";
import { Link } from "react-router-dom";
import { AuthContext } from "../providers/AuthProvider";
import { Icon } from "../components/icons/Icon";
import { menu } from "../components/icons/appIcons";

// Expose tiny primitives for common bits (optional but handy)
// Keep header/footer dumb; provide small ready-made pieces you can reuse
export function Brand({ children }) {
  return (
    <div className="font-semibold tracking-tight truncate brand">
      {children}
    </div>
  );
}

export function Copyright() {
  return <p>&copy; {new Date().getFullYear()} PWA App</p>;
}

export function Menu() {
  const { isLoggedIn } = useContext(AuthContext);
  return (
    <Navbar>
      {!isLoggedIn ? (
        <li className="nav-item">
          <Link key="/login" to="/login" className="login">
            <span>Login</span>
          </Link>
        </li>
      ) : (
        <></>
      )}
      <NavItem
        icon={
          <Icon
            icon={menu}
            size={32}
            width={32}
            height={32}
            strokeWidth={0.5}
            className="pointer-events-none"
          />
        }
      >
        <DropdownMenu />
      </NavItem>
    </Navbar>
  );
}
export function Spacer() {
  return <div className="flex-1" />;
}
